// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#smartrr_wrapper,
#smartrr_passwordless_form {
  font-family: "Inter";
  -webkit-font-smoothing: antialiased;
  letter-spacing: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/account/fonts.css"],"names":[],"mappings":"AACA;;EAEE,oBAAoB;EACpB,mCAAmC;EACnC,mBAAmB;AACrB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap\");\n#smartrr_wrapper,\n#smartrr_passwordless_form {\n  font-family: \"Inter\";\n  -webkit-font-smoothing: antialiased;\n  letter-spacing: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
